module.exports = __webpack_public_path__ + "img/triangle-45.f809f703.gif";